import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DetailPair } from '../../../../../../../shared/components/detail-info-card/DetailPair';
import { DataUtility } from '../../../../../../../utilities/DataUtility';
import { EquifaxDetailCardComponent } from '../equifax-detail-card/equifax-detail-card.component';


@Component({
  selector: 'app-guest-device-result-card',
  templateUrl: './guest-device-result-card.component.html',
  styleUrls: ['./guest-device-result-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
  
    EquifaxDetailCardComponent
  ]
})
export class GuestDeviceResultCardComponent implements OnInit {

  @Input() guest!: any;

  data: DetailPair[] = [];
  title = 'Device Trust';
  trustDecision!: string;

  deviceAssociationReason!: string;
  deviceReputationReason!: string;

  constructor(private dataUtility: DataUtility) { }

  ngOnInit() {
    this.deviceAssociationReason = this.dataUtility.getCheckReason(this.guest, 'deviceAssociationReason');
    this.deviceReputationReason = this.dataUtility.getCheckReason(this.guest, 'deviceReputationReason');

    this.populateDeviceTrustInfo();
  }

  populateDeviceTrustInfo() {
    this.trustDecision = this.dataUtility.getTrustInfo(this.guest, 'deviceTrust');

    this.data.push(new DetailPair("Association", this.dataUtility.getTrustInfo(this.guest, 'deviceAssociation') ? this.dataUtility.getTrustInfo(this.guest, 'deviceAssociation') : null, this.deviceAssociationReason));
    this.data.push(new DetailPair("Reputation", this.dataUtility.getTrustInfo(this.guest, 'deviceReputation') ? this.dataUtility.getTrustInfo(this.guest, 'deviceReputation') : null, this.deviceReputationReason));
  }

}